import { EMPTY_OBJECT } from '#pplx/frontend/common/defaults.js';
/** Whether a keyboard command is outside an active IME composition. */
export function isKeyboardCommandEligible(event) {
    // Safari reports IME composition keydowns with the legacy keyCode 229.
    return event !== null && !event.isComposing && event.keyCode !== 229;
}
/** Resolves the live keyboard configuration of every contributing plugin. */
export function resolveKeyboardConfigurations(plugins) {
    return plugins.flatMap((plugin) => {
        if (plugin.keyboard === undefined)
            return [];
        return [plugin.keyboard(plugin.props ?? EMPTY_OBJECT)];
    });
}
/** Reports a real editor mutation to every keyboard contribution. */
export function notifyKeyboardUserEdit(configurations) {
    configurations.forEach((configuration) => {
        if (configuration.disabled)
            return;
        configuration.onUserEdit?.();
    });
}
//# sourceMappingURL=keyboardCapabilityUtils.js.map